const updatePreviousLocations = (
  locationId: string,
  locationName: string,
  prevLocationId: string | null,
  prevLocationName: string | null,
) => {
  const prevLocationIds = prevLocationId ? prevLocationId.split(',') : [];
  const prevLocationNames = prevLocationName ? prevLocationName.split(',') : [];

  // Only add if the last stored location is different from the current one
  if (
    !prevLocationIds.length ||
    prevLocationIds[prevLocationIds.length - 1] !== locationId
  ) {
    prevLocationIds.push(locationId);
    prevLocationNames.push(locationName);
  }

  return {
    prevLocationId: prevLocationIds.join(','),
    prevLocationName: prevLocationNames.join(','),
  };
};

const getLevelLocationData = (ids: string, names: string, level: number) => {
  const idList = ids.split(',');
  const nameList = names.split(',');

  return {
    locationId: idList[level - 1] || '',
    locationName: nameList[level - 1] || '',
  };
};

export { updatePreviousLocations, getLevelLocationData };
